import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
  Menu,
  Dropdown,
  Radio,
} from "antd";
import { Document10 } from "./ReportDocuments/Document_10";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  BarChartOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FilterOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import ReportsTable from "./ReportsTable";
import * as XLSX from "xlsx-js-style";
import { LanguageContext } from "../../context/LanguageContext";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import { roleAction } from "../../_actions/roleby.action";
import { adminService } from "../../_services/admin.service";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";

const TableArrestReport = React.lazy(() =>
  import("./Tables/TableArrestReport").then((module) => ({
    default: module.TableArrestReport,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class ArrestReportAdmin extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    report4_List_Total: 0,
    report4_API_loader: false,
    totalCriminal: 0,
    crimeTitle: "",
    setCriminalViewModel: false,
    PlusViewForm_List: [],
    download: "excel",
    showList: "list",
    total: "0",
    showFilterSection: false,
    direction: "",
    key: "",
    advancedFilterPhoto: "all",
  };

  componentDidMount() {
    const { user } = this.props;
    this.props.dispatch(professionalAction.getCity());
    if (user && user.role == "2") {
      this.getDistrictsid();
    }
  }

  isSameDate(dates) {
    return (
      moment(dates[0]).isSame(dates[1], "day") &&
      moment(dates[0]).isSame(dates[1], "month") &&
      moment(dates[0]).isSame(dates[1], "year")
    );
  }
  getFormat(date) {
    if (isNaN(date)) {
      return moment(new Date(date).getTime(), "x").format("DD/MM/YY");
    } else {
      return moment(new Date().getTime(), "x").format("DD/MM/YY");
    }
  }

  isSameDateCompareWithData(compareDate, filterDate) {
    if (this.getFormat(compareDate) === this.getFormat(filterDate)) {
      return true;
    }
    return false;
  }

  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report4_List;

    return this.state.showList === "list"
      ? arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("crime_police_station")]: data.districtName,
          [t("registration_date")]: data.gunaDate
            ? moment(data.gunaDate).format("DD-MM-YYYY")
            : "-",
          [t("cr.no")]: data.registernumber,
          [t("name_of_the_accused")]: data.name,
          [t("law_and_section")]: (() => {
            let kkData = data.kk_info;
            if (typeof kkData === "string") try { kkData = JSON.parse(kkData); } catch { kkData = null; }
            if (!Array.isArray(kkData) || !kkData.length) return "-";
            const grouped = {};
            kkData.forEach((r) => {
              const name = r.rulesName || "-";
              const kalma = r.kalam || "-";
              grouped[name] = grouped[name]
                ? Array.from(new Set([...grouped[name], kalma]))
                : [kalma];
            });
            return Object.entries(grouped)
              .map(([n, k]) => `${n}: ${k.join(", ")}`)
              .join("\n");
          })(),
          [t("fir_registration_date")]: data.arrest_dateTime
            ? moment(data.arrest_dateTime).format("DD-MM-YYYY")
            : "-",
          [t("arrest_date_time")]: data.court_dateTime
            ? moment(data.court_dateTime, "YYYY-MM-DD").format("DD-MM-YYYY")
            : "-",
          [t("date_of_birth")]: data.criminal_dob
            ? moment(data.criminal_dob).format("DD-MM-YYYY")
            : "-",
          [t("aadhaar_number")]: data.aadharno ? data.aadharno : "-",
          [t("photo")]: data.photo != "" ? t("yes") : t("no"),
        })) || []
      : arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("accused_police_station")]: data?.districtName,
          [t("total")]: data?.crimeCount,
        })) || [];
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("arrest_register_report");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    console.log("this.props", this.props);
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    // if (download == "pdf") {
    //   this.download_pdf();
    // }
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
      heading: this.state.crimeTitle,
    };
    this.setState({
      report4_loader: true,
    });
    const blob = await pdf(
      <Document10
        rows={this.state.report4_List}
        filterDate={obj}
        allTotal={this.state.totalCriminal}
        total={this.state.report4_List_Total}
      />,
    ).toBlob();

    if (blob) {
      this.setState({
        report4_loader: false,
      });
      saveAs(blob, "Arrest Report");
    }
  };
  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  download_csv = () => {
    const { t } = this.context;
    const { showList } = this.state;
    var ReportTitle = t("arrest_register_report");
    var title = t("arrest_register_report");
    var arrData1 = this.state.report4_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      showList === "list"
        ? arrData1?.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data.accused_police_station,
            [t("name_of_the_accused")]: data.name,
            [t("address")]: data.address,
            [t("crime_police_station")]: data.districtName,
            [`${t("cr.no")}/${t("registration_date")}`]: `${data.registernumber || "-"}/${data.gunaDate ? moment(data.dateTime).format("DD-MM-YYYY") : "-"}`,
            [t("law_and_section")]: (() => {
              let kkData = data.kk_info;
              if (typeof kkData === "string") try { kkData = JSON.parse(kkData); } catch { kkData = null; }
              if (!Array.isArray(kkData) || !kkData.length) return "-";
              const grouped = {};
              kkData.forEach((r) => {
                const name = r.rulesName || "-";
                const kalma = r.kalam || "-";
                grouped[name] = grouped[name]
                  ? Array.from(new Set([...grouped[name], kalma]))
                  : [kalma];
              });
              return Object.entries(grouped)
                .map(([n, k]) => `${n}: ${k.join(", ")}`)
                .join("\n");
            })(),
            [t("arrest_date_time")]: data.arrest_dateTime
              ? moment(data.arrest_dateTime, "YYYY-MM-DD").format("DD-MM-YYYY")
              : "-",
            [t("date_of_birth")]: data.criminal_dob
              ? moment(data.criminal_dob).format("DD-MM-YYYY")
              : "-",
            [t("aadhaar_number")]: data.aadharno ? data.aadharno : "-",
            [t("photo")]: data.photo != "" ? t("yes") : t("no"),
          })) || []
        : arrData1?.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data?.districtName,
            [t("total")]: data?.crimeCount,
          }));

    const arrData = list;
    // ===================== STYLES =====================
    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // ===================== WORKBOOK =====================
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;

    const cityName = this.getCityName(this.props?.user?.cityId || "");
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;

    const headerData =
      this.props?.user?.role === "2" ? `${stateName} (${cityName})` : cityName;

    // ===================== TITLES =====================
    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    // ===================== TABLE HEADERS (A3) =====================
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });

    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    // ===================== TABLE DATA (A4) =====================
    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });

    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    // ===================== FOOTER =====================
    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", wrapText: true },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    // ===================== FORMATTING =====================
    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];

    for (let i = 3; i < ws_data.length + 3; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }

    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };

    ws["!freeze"] = { ySplit: 3 };
    ws["!merges"] = merges;

    // ===================== EXPORT =====================
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  onViewAccusedForm = (data) => {
    if (data) {
      let obj = {
        startDate: this.state.report_4_startDate,
        endDate: this.state.report_4_endDate,
        id: data,
        heading: this.state.crimeTitle,
      };
      this.props.dispatch(professionalAction.get2PlusCriminalsViewsById(obj));
      this.showCriminalViewModel();
    }
  };
  generatePDFReport1 = async () => {
    const { user } = this.props;
    const { showList } = this.state;
    this.setState({
      report4_API_loader: true,
    });
    if (showList === "list") {
      let obj;
      if (user.role === "4") {
        obj = {
          startDate: this.state.report_4_startDate,
          endDate: this.state.report_4_endDate,
          cityId: user && user.cityId,
        };
      } else {
        obj = {
          startDate: this.state.report_4_startDate,
          endDate: this.state.report_4_endDate,
          id: user && user.districtId,
        };
      }

      if (user.role === "4" || user.role === "2") {
        professionalAction.getArrestReport(obj).then((res) => {
          res &&
            res &&
            res.text().then(async (text) => {
              const tempData = text && JSON.parse(text);
              console.log("tempData", tempData);
              let tempFilterData = _.filter(
                tempData && _.flatten(tempData),
                function (o) {
                  return Object.keys(o).length !== 0;
                },
              );
              this.setState({
                report4_API_loader: false,
                report4_List: tempFilterData,
                report4_List_backup: tempFilterData,
                total: tempFilterData.length,
              });
            });
        });
      }
      if (user.role === "9" || user.role === "10") {
        let obj = {
          startDate: this.state.report_4_startDate,
          endDate: this.state.report_4_endDate,
          districtId: user && user.map_districtId,
        };
        roleAction.getArrestReportByRole(obj).then((res) => {
          res &&
            res &&
            res.text().then(async (text) => {
              const tempData = text && JSON.parse(text);
              console.log("tempData", tempData);
              let tempFilterData = _.filter(
                tempData && _.flatten(tempData),
                function (o) {
                  return Object.keys(o).length !== 0;
                },
              );
              this.setState({
                report4_API_loader: false,
                report4_List: tempFilterData,
                report4_List_backup: tempFilterData,
                total: tempFilterData.length,
              });
            });
        });
      }
    } else {
      if (user?.role === "4") {
        let obj = {
          startDate: this.state.report_4_startDate,
          endDate: this.state.report_4_endDate,
          cityId: user && user.cityId,
        };
        adminService.getArrestCountCityWise(obj).then((res) => {
          res &&
            res &&
            res.text().then(async (text) => {
              const tempData = text && JSON.parse(text);
              console.log("tempData", tempData);
              let totalCrimeCount = tempData?.results.reduce(
                (sum, res) => sum + (Number(res.crimeCount) || 0),
                0,
              );
              this.setState({
                report4_API_loader: false,
                report4_List: tempData?.results,
                total: totalCrimeCount,
              });
            });
        });
      }
      if (user?.role === "9" || user?.role === "10") {
        let obj = {
          startDate: this.state.report_4_startDate,
          endDate: this.state.report_4_endDate,
          districtId: user && user.map_districtId,
        };
        roleAction.getArrestCountByRole(obj).then((res) => {
          res &&
            res &&
            res.text().then(async (text) => {
              const tempData = text && JSON.parse(text);
              console.log("tempData", tempData);
              let totalCrimeCount = tempData?.results.reduce(
                (sum, res) => sum + (Number(res.crimeCount) || 0),
                0,
              );
              this.setState({
                report4_API_loader: false,
                report4_List: tempData?.results,
                total: totalCrimeCount,
              });
            });
        });
      }
    }
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      let dates =
        values &&
        values.map((item) => {
          return item.toISOString();
        });

      this.setState({
        report_4_startDate: dates[0],
        report_4_endDate: dates[1],
      });
    }
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null,
      });
    }
  };
  onEndDateChange = (date) => {
    if (date) {
      const endDate = date.toISOString();

      this.setState({
        report_4_endDate: endDate,
      });
    }
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report4_List } = this.state;

    const sortedData = [...report4_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report4_List: sortedData });
  };

  handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;
    this.setState({ advancedFilterPhoto: value });

    const { report4_List_backup, report4_List } = this.state; // keep original data safe

    let filtered;

    if (value === "yes") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      );
    } else if (value === "no") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo === null || item.photo === "" || item.photo === undefined,
      );
    } else {
      filtered = report4_List_backup;
    }

    this.setState({ report4_List: filtered, total: filtered.length });
  };

  render() {
    const { showList, key, direction, advancedFilterPhoto } = this.state;
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading, pc_crimetitles } = professionals;
    const { language, t } = this.context;
    console.log("user", user);
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        {this.state.showList == "list" ? (
          <>
            <Menu.Item key="registernumber">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                गुन्हा नंबर
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "registernumber" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("registernumber", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "registernumber" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("registernumber", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        ) : (
          <>
            <Menu.Item key="crimeCount">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {t("total")}
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "crimeCount" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("crimeCount", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "crimeCount" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("crimeCount", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        )}
      </Menu>
    );
    return (
      <Spin spinning={this.state.loading} delay={500}>
        <div className="col-md-12">
          {/* Title Section */}

          <div
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
           

            {/* ------- FIRST LINE: ALL FILTERS IN ONE ROW -------- */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px",
                justifyContent: "space-between",
              }}
            >
              {/* Left: Date Pickers + Find */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  {t("select_date")}:
                </span>

                <DatePicker
                  value={
                    this.state.report_4_startDate
                      ? moment(this.state.report_4_startDate)
                      : null
                  }
                  onChange={this.onStartDateChange}
                  placeholder="DD/MM/YYYY"
                  inputReadOnly
                  format="DD/MM/YYYY"
                  style={{ minWidth: "150px" }}
                />

                <DatePicker
                  value={
                    this.state.report_4_endDate
                      ? moment(this.state.report_4_endDate)
                      : null
                  }
                  onChange={this.onEndDateChange}
                  placeholder="DD/MM/YYYY"
                  inputReadOnly
                  format="DD/MM/YYYY"
                  style={{ minWidth: "150px" }}
                />

                <Button
                  type="primary"
                  disabled={!this.state.report_4_startDate}
                  loading={this.state.report4_API_loader}
                  onClick={this.generatePDFReport1}
                >
                  {t("find")}
                </Button>
              </div>

              {/* Right: Download + Sort */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Select
                  value={this.state.download}
                  onChange={(value) => this.setState({ download: value })}
                  style={{ width: "120px" }}
                  placeholder={t("please_select_an_option")}
                  disabled={!this.state.report4_List.length}
                >
                  <Option value="excel">{t("excel")}</Option>
                  <Option value="pdf">PDF</Option>
                </Select>

                <Button
                  type="primary"
                  disabled={
                    !this.state.download || !this.state.report4_List.length
                  }
                  onClick={() => this.downloadReport()}
                >
                  {t("download")}
                </Button>

                <Dropdown
                  overlay={menu}
                  placement="bottomRight"
                  arrow
                  disabled={!this.state.report4_List?.length}
                >
                  <Button type="ghost">
                    {t("sorter_by")} <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </div>

            {/* ------- SECOND LINE: PHOTO FILTER ONLY -------- */}
            {this.state.showList === "list" && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <label style={{ fontSize: "15px", fontWeight: "500" }}>
                  फोटो:
                </label>

                <Radio.Group
                  onChange={this.handleAdvancedFilterPhotoChange}
                  value={this.state.advancedFilterPhoto}
                >
                  <Radio value="all">सर्व</Radio>
                  <Radio value="yes">होय</Radio>
                  <Radio value="no">नाही</Radio>
                </Radio.Group>
              </div>
            )}
          </div>

          <React.Suspense fallback={<div>Loading...</div>}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                alignItems: "center",
                padding: "12px",
                background: "#f5f5f5",
                borderRadius: "8px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                {" "}
                {this.props.user?.role != "2" && (
                  <Button
                    type={showList == "count" ? "primary" : "default"}
                    icon={<BarChartOutlined />}
                    style={{
                      minWidth: "120px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                    onClick={() => {
                      this.setState({
                        showList: "count",
                        report4_List: [],
                      });
                    }}
                  >
                    {t("statistics")}
                  </Button>
                )}
                <Button
                  type={showList == "list" ? "primary" : "default"}
                  icon={<UnorderedListOutlined />}
                  style={{
                    minWidth: "120px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                  onClick={() => {
                    this.setState({
                      showList: "list",
                      report4_List: [],
                    });
                  }}
                >
                  {t("list")}
                </Button>
              </div>
            </div>

            <TableArrestReport
              key={this.state.report4_List}
              data={this.state.report4_List}
              startDate={this.state.report_4_startDate}
              endDate={this.state.report_4_endDate}
              allTotal={this.state.report4_List.length}
              total={this.state.total}
              onViewAccusedForm={this.onViewAccusedForm}
              showList={showList}
              loading={this.state.report4_API_loader}
              professionals={this.props.professionals}
              user={this.props.user}
            ></TableArrestReport>
          </React.Suspense>

          <Modal
            title="आरोपी प्रोफाइल"
            top
            visible={this.state.setCriminalViewModel}
            onOk={this.closeCriminalViewModel}
            onCancel={this.closeCriminalViewModel}
            width={95 + "%"}
          >
            <ViewFormModel
              key={this.props && this.props.user.id}
              dataStates={professionals}
            ></ViewFormModel>
          </Modal>
          {/* <ReportsTable
            isNotloading={this.isNotloading}
            ref={this.myTableRef}
            rows={this.state.report4_List}
            startDate={this.state.report_4_startDate}
            endDate={this.state.report_4_endDate}
            cityId={
              this.props ? this.props?.user && this.props?.user.cityId : null
            }
            heading="अटक रजिस्टर"
            allTotal={this.state.totalCriminal}
            total={this.state.report4_List_Total}
            cityName={this.getCityName(
              this.props?.user && this.props?.user.cityId
            )}
            user={this.props?.user?.role}
            report_type="अटक_रजिस्टर"
            report_name="अटक रजिस्टर"
          /> */}
        </div>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedArrestReportAdmin = connect(mapStateToProps)(ArrestReportAdmin);
export { connectedArrestReportAdmin as ArrestReportAdmin };
